// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cd23c7b9","515":"7e7faa79"}[chunkId] + ".chunk.js";
};